// Base path of the main Imperium site that hosts this CX app.
// '' at the domain root, or e.g. '/imperium' when served from a sub-folder
// like listeniqapp.com/imperium/. The CX build always lives at <base>/cx/, so
// we recover <base> by stripping the '/cx...' tail from the current URL path.
// Works with HashRouter because the hash never changes window.location.pathname.
export const SITE_BASE =
  (typeof window !== "undefined" ? window.location.pathname : "").replace(
    /\/cx(\/.*)?$/,
    ""
  );

// Prefix a root-absolute main-site asset path (e.g. "/assets/pdf/x.pdf") with
// the base. Full URLs (http/https/protocol-relative) are returned unchanged;
// empty input stays empty.
export function siteAsset(path) {
  const p = String(path || "");
  if (!p) return p;
  if (/^(https?:)?\/\//.test(p)) return p;
  return SITE_BASE + (p.startsWith("/") ? p : "/" + p);
}
